import useItemController from 'components/Dashboard/ItemController/useItemController';

const useListItemController = ({
  item,
  index,
  feedItemFlags,
  itemFromWidget,
  listView,
  hideYellowDot,
  thumbDownProps,
  showPriorityBadge,
  itemName,
}) => {
  return useItemController({
    item,
    index,
    propsFeedItemFlags: feedItemFlags,
    itemFromWidget,
    listView,
    hideYellowDot,
    thumbDownProps,
    showPriorityBadge,
    itemName,
  });
};

export default useListItemController;

